import authenticationReducer from './reducers/authenticationReducer';
import layoutReducer from '@store/reducers/LayoutReducer';
import navbarReducer from './reducers/navbarReducer';
import ticketSlice from './reducers/ticketReducer';
export const RootReducer = {
  layout: layoutReducer,
  navbar: navbarReducer,
  authentication: authenticationReducer,
  ticket: ticketSlice,
};

export default RootReducer;
